import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "pdf-container"
};
const _hoisted_2 = {
  class: "pdf-controls"
};
const _hoisted_3 = {
  key: 0,
  class: "content-box mt-4 relative overflow-hidden py-px"
};
const _hoisted_4 = {
  class: "title flex items-center justify-between px-3"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = {
  class: "pdf-content overflow-hidden"
};
import { ref, computed, inject, watch, nextTick } from 'vue';
import { downloadFile } from '@/utils/file-helpers';
import pdfReader from '@components/pdfReader.vue';
import AnimateText from '../AnimateText.vue';
import useMainStore from '../../main.store';
export default /*@__PURE__*/_defineComponent({
  __name: 'PDFReport',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const mainStore = useMainStore();
    const AnimateTextRef = ref();
    const show = ref(true);
    const loading = ref(false);
    const downloading = ref(false);
    const openSidePreview = inject('openSidePreview');
    const hideBtn = ref(true);
    const info = computed(() => {
      if (props.content) {
        try {
          return props.content;
        } catch {
          return {
            attachmentDetail: {}
          };
        }
      }
      return {
        attachmentDetail: {}
      };
    });
    const handleEnlargeReding = () => {
      openSidePreview({
        title: info.value.reportName,
        showDownload: true,
        url: info.value.attachmentDetail.filePath
      });
    };
    const shortName = () => {
      const str = info.value.reportName;
      // 使用 lastIndexOf 确保正确处理含多个点的文件名
      const dotIndex = str.lastIndexOf('.');
      let fileName = str;
      let ext = 'pdf';
      if (dotIndex > 0 && dotIndex < str.length - 1) {
        fileName = str.substring(0, dotIndex);
        ext = str.substring(dotIndex + 1);
      }
      return `${fileName}.${ext}`;
    };
    const downloadPDF = async () => {
      if (downloading.value) return;
      downloading.value = true;
      console.log('下载PDF:', shortName());
      try {
        await downloadFile(info.value.attachmentDetail.filePath, shortName());
      } catch (error) {
        console.error('PDF下载失败:', error);
      } finally {
        downloading.value = false;
      }
    };
    function handleEnd() {
      show.value = true;
      loading.value = true;
      setTimeout(() => {
        loading.value = false;
        mainStore.loadNextMsg(props.item);
      }, 2000);
    }
    watch(() => props.item.openAnimate, async newVal => {
      if (newVal) {
        show.value = false;
        await nextTick();
        AnimateTextRef.value?.typeWriter(info.value.tips || '');
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(AnimateText, {
        text: __props.item.openAnimate ? '' : info.value.tips,
        ref_key: "AnimateTextRef",
        ref: AnimateTextRef,
        onEnd: handleEnd
      }, null, 8, ["text"])]), show.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "truncate mr-2 max-w-[200px]",
        title: info.value.reportName
      }, _toDisplayString(info.value.reportName), 9, _hoisted_5), _createVNode(_component_el_button, {
        type: "text",
        onClick: downloadPDF,
        loading: downloading.value
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
          class: "text-xs"
        }, "下载报告", -1)]))]),
        _: 1
      }, 8, ["loading"])]), _createElementVNode("div", _hoisted_6, [_createVNode(pdfReader, {
        pdfUrl: info.value.attachmentDetail.filePath,
        onRenderError: _cache[0] || (_cache[0] = $event => hideBtn.value = true),
        onRenderOver: _cache[1] || (_cache[1] = $event => hideBtn.value = false)
      }, null, 8, ["pdfUrl"])]), !hideBtn.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "enlarge-reading",
        onClick: handleEnlargeReding
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 放大阅读 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]]) : _createCommentVNode("", true)]);
    };
  }
});